<app-toolbar-item (click)="locateUser()">
  <app-icon class="text-24" name="target" [ngClass]="geolocateClassList()" />
</app-toolbar-item>
